import React, { useEffect, useState } from 'react';
import './style.scss';
import { HOME_PAGE, TINH_NANG } from 'global/routes';
import logo_vnpt from 'assets/imgs/logo_home.png';
import flag_VN from 'assets/imgs/flag-vn.png';
import flag_UK from 'assets/imgs/flag-uk.png';
import mail from 'assets/imgs/mail.png';
import carretDown from 'assets/imgs/carret-down.png';
import noel1 from 'assets/imgs/noel1.svg';
import noel2 from 'assets/imgs/noel2.svg';
import { UserService } from 'services/UserService';
import { FormattedMessage } from 'react-intl';
import { InputSearch, Notification, OutsideClick } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import Search from './Component/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/fontawesome-free-solid';
import { Link, useHistory } from 'react-router-dom';
import Login from 'pages/Login/Login';
import { doLogout } from 'store/action/userAction';
import { changeLocale } from 'store/action/languageAction';
import { SELFCARE } from 'global/environment';

const PATH = [
  '/tinh-nang',
  '/ekyc',
]

const LIST_TITLE = [
  {
    title: 'IDS_HOME_PAGE',
    url: '/',
  },
  {
    title: 'IDS_TV_GOI_CUOC',
    url: '/dich-vu',
    menuList: [
      { name: 'IDS_TV_GOIDIDONG', href: '/dich-vu/goi-cuoc-di-dong' },
      { name: 'IDS_HOME_COMBO', href: '/dich-vu/home-combo' },
      { name: 'IDS_HOME_INTERNET', href: '/dich-vu/home-internet' },
      { name: 'IDS_HOME_TV', href: '/dich-vu/home-tv' },
      // { name: 'IDS_TV_GOIMYTV', href: '/dich-vu/mytv' },
      { name: 'IDS_TV_GOIMYTV_OTT', href: '/dich-vu/mytv-ott' },
      { name: 'IDS_TV_GTGT', href: '/dich-vu/gtgt' },
      { name: 'IDS_TVCODINH', href: '/dich-vu/co-dinh' },
      { name: 'IDS_TV_GOI_FAMILY', href: '/dich-vu/gia-dinh-van-phong' },
      // { name: 'IDS_DIGILIFE_PACKAGE', href: '/dich-vu/digilife' },
    ]
  },
  {
    title: 'IDS_TV_HO_TRO_KHACH_HANG',
    url: '/tinh-nang/gui-yeu-cau',
    menuList: [
      { name: 'IDS_ELECTRICINVOICE', href: "/tinh-nang/hoa-don-dien-tu" },
      { name: 'IDS_SHELPGUIYEUCAU', href: "/tinh-nang/gui-yeu-cau" },
      { name: 'IDS_REFLECT_SERVICE_QUALITY', href: "/tinh-nang/phan-anh-chat-luong" },
      { name: 'IDS_SHELPYEUCAUDAGUI', href: "/tinh-nang/yeu-cau-da-gui" },
      { name: 'IDS_TV_DIA_DIEM_STORE', href: "/tinh-nang/dia-diem-cua-hang" },
      { name: 'IDS_TV_DANG_KY_DOI_SIM', href: "/tinh-nang/dang-ky-doi-sim-4g" },
      { name: 'IDS_FAQ', href: "/tinh-nang/hoi-dap" },
      { name: 'IDS_TV_DK_DK', href: "/tinh-nang/dieu-khoan-su-dung" },
      { name: 'IDS_TV_DK_CSBVDL', href: "/tinh-nang/chinh-sach-rieng-tu" },
      { name: 'IDS_TV_SMART_TV_SUPPORT', href: "/tinh-nang/smart-tv-ho-tro-mytv" },
      { name: 'IDS_MANAGE_MULTISIM', href: "/tinh-nang/quan-ly-multisim" },
      { name: 'IDS_TV_DOI_SIM_EZCOM', href: "/tinh-nang/doi-sim-ezcom" },
      { name: 'IDS_APP', href: "/tinh-nang/ung-dung" },
    ]
  },
];

const LIST_FEATURE = [
  { title: 'IDS_TV_QLTK_GOI_CUOC', url: `${TINH_NANG}/thong-tin-ca-nhan` },
  { title: 'IDS_MANAGER_INTERNET_MYTV', url: `${TINH_NANG}/quan-ly-home-internet` },
  { title: 'IDS_TV_HIS', url: `${TINH_NANG}/lich-su-su-dung` },
  { title: 'IDS_TV_CHANGE_PASS', url: `${TINH_NANG}/doi-mat-khau` },
  { title: 'IDS_TV_HO_TRO_KHACH_HANG', url: `${TINH_NANG}/hoi-dap` },
  { title: 'IDS_TV_THANH_TOAN', url: `${TINH_NANG}/thanh-toan-dich-vu` },
  { title: 'IDS_NEWS_PROMOTION', url: `${TINH_NANG}/tin-tuc` },
]

const TitleItem = ({ title, menuList, url, authorized }) => (
  <div className="header__item-wrapper">
    <Link to={url}>
      <span><FormattedMessage id={title} /></span>
      {menuList && <img src={carretDown} alt="icon" className="ml-2" />}
    </Link>

    {menuList &&
      <ul className="header__dropdown-menu">
        {menuList.map((item, index) => (
          <React.Fragment key={index}>
            {(authorized || (item.name !== 'IDS_MANAGE_MULTISIM' && item.name !== 'IDS_TV_DOI_SIM_EZCOM')) &&
              <li><Link to={item.href}><FormattedMessage id={item.name} /></Link></li>
            }
          </React.Fragment>
        ))}
      </ul>
    }
  </div>
);

const Header = () => {
  const [isOpenModalLogin, setOpenModalLogin] = useState(false);
  const [fixedHeader, setFixedHeader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [valueSearch, setValueSearch] = useState('');
  // const [showMenu, setShowMenu] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const authorized = useSelector(state => state.authorizedReducer.authorized);
  const locale = useSelector(state => state.language.locale);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fixedHeader]);

  const handleScroll = () => {
    const sticky = document.documentElement.scrollTop;
    if (sticky > 50) {
      setFixedHeader(true);
    } else if (fixedHeader && sticky === 0) {
      setFixedHeader(false);
    }
  }

  const handleLogOut = () => {
    const data = {
      msisdn: localStorage.getItem('mobile'),
    };

    UserService.logout(data, res => {
      if (res.error_code === '0') {
        dispatch(doLogout());
        localStorage.clear();
        Notification.success("Đăng xuất thành công");

        const found = PATH.some(item => history.location.pathname?.includes(item)); // check url contain pathname
        if (found) {
          history.push('/');
        }
      } else {
        Notification.error("Có lỗi xảy ra!");
      }
    }, () => {
      Notification.error("Có lỗi xảy ra!");
    });
  }

  const handleChange = value => {
    localStorage.setItem('language', value);
    dispatch(changeLocale(value));
  };

  const handleOnSearch = () => {
    if (valueSearch?.trim() === '') {
      return;
    }
    const search = valueSearch.replace(/\s|%/g, "+");
    history.push(`/tim-kiem/${search}`);
    setValueSearch('');
  }

  return (
    <>
      <div className={`header-wrapper-top ${fixedHeader ? 'height-0' : ''}`}>
        <div className="container header-top d-none d-md-flex">
          <div className="header-top__left">
            <p><FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' />: <a href="tel:18001091">18001091</a></p>
            <p><FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' />: <a href="tel:18001166">18001166</a></p>
            <p className="display-center">
              <img alt="img" src={mail} />
              <span className="ml-2">cskh@vnpt.vn</span>
            </p>
          </div>

          <div className='d-flex header-top__end'>
            <div className='selfcare'>
              <a className='active' href='/' onClick={(e) => {e.preventDefault()}} >Cá nhân</a>
            </div>
            <div className='selfcare'>
              <a href={SELFCARE}>Doanh nghiệp</a>
            </div>

            {locale === 'vi' &&
              <div className="header-top__flag" onClick={() => handleChange('en-US')}>
                <img alt="flag" src={flag_UK} />
                <span className="ml-3">English</span>
              </div>
            }
            {locale === 'en-US' &&
              <div className="header-top__flag" onClick={() => handleChange('vi')}>
                <img alt="flag" src={flag_VN} />
                <span className="ml-3">Việt Nam</span>
              </div>
            }
          </div>

        </div>

        <div className="container header-top d-md-none">
          <p><FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' />: 18001091</p>
          <p><FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' />: 18001166</p>

          <div className="display-center">
            <div className="header-top__mail">
              <img alt="img" src={mail} />
              <span className="ml-2">cskh@vnpt.vn</span>
            </div>

            {locale === 'vi' &&
              <div className="header-top__flag" onClick={() => handleChange('en-US')}>
                <img alt="flag" src={flag_UK} />
                <span className="ml-3">English</span>
              </div>
            }
            {locale === 'en-US' &&
              <div className="header-top__flag" onClick={() => handleChange('vi')}>
                <img alt="flag" src={flag_VN} />
                <span className="ml-3">Việt Nam</span>
              </div>
            }
          </div>
        </div>
      </div>

      <div className={`header-wrapper ${fixedHeader ? 'sticky' : ''}`}>
        <div className={`container header ${openMenu ? 'open-menu' : ''}`}>
          <div className="d-flex">
            <Link to={HOME_PAGE}>
              <img alt="home" src={logo_vnpt} className='header__icon-home' />
            </Link>
            {/* <img alt="noel" src={noel2} className='header__icon-noel1 d-none d-md-block' />
            <img alt="noel" src={noel1} className='header__icon-noel2 d-md-none' /> */}
          </div>


          <div className="d-none d-lg-block">
            <div className="display-sb">
              {LIST_TITLE.map((item, index) => (
                <TitleItem
                  key={index}
                  title={item.title}
                  menuList={item.menuList}
                  url={item.url}
                  authorized={authorized}
                />
              ))}

              <div className="header__item-wrapper">
                <a href="https://vinaphoneplus.com.vn/" target="_blank" rel="noopener noreferrer">
                  <span><FormattedMessage id='IDS_VINAPHONE_PLUS' /></span></a>
              </div>

              {authorized &&
                <div className="header__item-wrapper">
                  <p><FormattedMessage id='IDS_HELLO' /> {`0${localStorage.getItem('mobile')?.slice(2)}`}</p>
                </div>
              }
              {!authorized &&
                <div className="header__item-wrapper" onClick={() => setOpenModalLogin(true)}>
                  <p><FormattedMessage id='IDS_TV_SIGN_IN' /></p>
                </div>
              }
              {authorized &&
                <div className="header__feature header__item-wrapper">
                  <div className="header__close-btn feature-btn">
                    <span style={{ opacity: 0 }}>VNPT</span>
                    <div />
                  </div>

                  <ul className="header__dropdown-menu">
                    {LIST_FEATURE.map((item, index) => (
                      <li key={index}>
                        <FontAwesomeIcon color="#000" icon={faCaretRight} size="1x" className="mr-3" />
                        <Link to={item.url}><FormattedMessage id={item.title} /></Link>
                      </li>
                    ))}
                    <li className="header__item-wrapper" onClick={handleLogOut}>
                      <FontAwesomeIcon color="#000" icon={faCaretRight} size="1x" className="mr-3" />
                      <span><FormattedMessage id='IDS_TV_SIGN_OUT' /></span>
                    </li>
                  </ul>
                </div>
              }

              <Search
                valueSearch={valueSearch}
                setValueSearch={setValueSearch}
                onEnter={handleOnSearch}
                clickOutSide={() => setValueSearch('')}
              />
            </div>
          </div>


          <div className="d-lg-none">
            <div className="d-flex">
              <InputSearch
                value={valueSearch}
                handleOnChange={(value) => setValueSearch(value)}
              />
              <OutsideClick onClickOutSide={() => setOpenMenu(false)}>
                <div className="header__close-btn" onClick={() => setOpenMenu(!openMenu)}>
                  <div />
                </div>

                <div className="header__menu-dropdown">
                  {LIST_TITLE.map((item, index) => (
                    <TitleItem
                      key={index}
                      title={item.title}
                      menuList={item.menuList}
                      url={item.url}
                      authorized={authorized}
                    />
                  ))}
                  {authorized &&
                    <div className="header__item-wrapper">
                      <p>
                        <span><FormattedMessage id='IDS_FEATURE' /></span>
                        <img src={carretDown} alt="icon" className="ml-2" />
                      </p>

                      <ul className="header__dropdown-menu">
                        {LIST_FEATURE.map((item, index) => (
                          <li key={index}>
                            <Link to={item.url}><FormattedMessage id={item.title} /></Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  }

                  <div className="header__item-wrapper">
                    <a href="https://vinaphoneplus.com.vn/" target="_blank" rel="noopener noreferrer">
                      <span><FormattedMessage id='IDS_VINAPHONE_PLUS' /></span></a>
                  </div>

                  {authorized &&
                    <div className="header__item-wrapper" onClick={handleLogOut}>
                      <p><FormattedMessage id='IDS_TV_SIGN_OUT' /></p>
                    </div>
                  }
                  {!authorized &&
                    <div className="header__item-wrapper" onClick={() => setOpenModalLogin(true)}>
                      <p><FormattedMessage id='IDS_TV_SIGN_IN' /></p>
                    </div>
                  }
                </div>
              </OutsideClick>
            </div>
          </div>
        </div>

        {isOpenModalLogin &&
          <Login
            isOpenModalLogin={isOpenModalLogin}
            closeModalLogin={() => setOpenModalLogin(false)}
          />
        }
      </div>
    </>
  );
};

export default React.memo(Header);
